export default __webpack_public_path__ + "static/media/shin.47ac6e36.jpg";